module.exports = __webpack_public_path__ + "static/media/private-cal.b1288b4f.svg";